import styles from "./StatusTag.module.css";
import { STATUS_OPTIONS } from "../../utils/constants";

const statusColors: { [key: string]: string } = {
  PENDING: "#FAAD14",
  RUNNING: "#FAAD14",
  SUCCESS: "#008774",
  FAILED: "#FF4D4F",
  CANCELLED: "#9E9E9E",
  DEFAULT: "#9E9E9E",
};

const StatusTag = ({
  status,
  error,
}: {
  status?: string;
  error?: string;
}) => {

  const statusOption = STATUS_OPTIONS.find(option => option.value === status);
  const tagText = statusOption?.label || "-";
  const tagColor = status ? (statusColors[status] || statusColors.DEFAULT) : statusColors.DEFAULT;

  const displayText = error ? `${tagText} - ${error}` : tagText;

  return (
    <span className={styles.tag}>
      <span className={styles.dot} style={{ backgroundColor: tagColor }}></span>
      {displayText}
    </span>
  );
};

export default StatusTag;
